import React, { useEffect, useState } from "react";
import { Col, Row, Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";

const REQUIRED_DOCUMENTS = {
  business: {
    title: "Badan hukum",
    information: "Perseroan Terbatas / CV / Perseroan Perorangan / UD",
    mandatory: [
      [
        "KTP Penanggung Jawab (PIC)",
        "NPWP Perusahaan",
        "Akta Pendirian",
        "SK Kemenkumham Pendirian",
        "Akta Perubahan Terakhir",
        "SK Kemenkumham Perubahan Terakhir",
      ],
      [
        "NIB Berbasis Resiko",
        "KTP dan/atau NPWP Pengurus (Direktur dan/atau Komisaris)",
        "Laporan Keuangan minimal 1 Tahun Terakhir",
        "Rekening Koran 3 Bulan Terakhir",
      ],
    ],
    optional: [["Dokumen Jaminan"], ["Dokumen Pendukung lainnya"]],
  },
  personal: {
    title: "Perorangan",
    information: null,
    mandatory: [
      [
        "KTP Penanggung Jawab (PIC)",
        "KTP Peminjam",
        "Rekening Koran 3 Bulan Terakhir",
      ],
      [
        "Akta Pernikahan (jika status menikah)",
        "KTP Pasangan (jika status menikah)",
      ],
    ],
    optional: [["Dokumen Jaminan"], ["Dokumen Pendukung lainnya"]],
  },
};

type DocumentType = keyof typeof REQUIRED_DOCUMENTS; // 'business' | 'personal'

const INTERVAL_TIME = 20 * 1000;
let interval: NodeJS.Timeout;

interface IProps {
  fontSizeTitle: string;
  fontSizeContentTitle: string;
  fontSizeContent: string;
}

function RequiredDocuments({
  fontSizeTitle,
  fontSizeContentTitle,
  fontSizeContent,
}: IProps) {
  const [keyDocs, setKeyDocs] = useState("business");
  useEffect(() => {
    if (interval) {
      clearTimeout(interval);
    }
    interval = setTimeout(() => {
      if (keyDocs === "business") {
        setKeyDocs("personal");
      }
      if (keyDocs === "personal") {
        setKeyDocs("business");
      }
    }, INTERVAL_TIME);
  }, [keyDocs]);

  return (
    <React.Fragment>
      <div
        className={`fw-extra-bold mb-2 text-center text-size-${fontSizeTitle}`}
      >
        Persyaratan Dokumen
      </div>
      <Tabs
        className={`themed-tabs text-size-${fontSizeContentTitle}`}
        activeKey={keyDocs}
        onSelect={(k) => {
          if (!k) k = "business";
          setKeyDocs(k);
        }}
        fill
        justify
      >
        {(Object.keys(REQUIRED_DOCUMENTS) as DocumentType[]).map((a) => {
          const item = REQUIRED_DOCUMENTS[a];
          const [leftColMandatory, rightColMandatory] = item.mandatory;
          const [leftColOptional, rightColOptional] = item.optional;
          return (
            <Tab
              key={a}
              eventKey={a}
              title={
                <div className="d-flex justify-content-center gap-2 align-items-center">
                  <div>{item.title}</div>
                  {item.information ? (
                    <OverlayTrigger
                      overlay={<Tooltip>{item.information}</Tooltip>}
                    >
                      <FaInfoCircle className="text-primary-main" />
                    </OverlayTrigger>
                  ) : null}
                </div>
              }
            >
              <Tab.Content className="border border-top-0 p-4 bg-primary-o-lighter">
                <div
                  className={`text-size-${fontSizeContentTitle} fw-bold`}
                >
                  Wajib
                </div>
                <Row>
                  <Col md={6}>
                    <ul className={`m-0 text-size-${fontSizeContent}`}>
                      {leftColMandatory.map((doc, index) => (
                        <li key={`${a}-${index}`}>{doc}</li>
                      ))}
                    </ul>
                  </Col>
                  <Col md={6}>
                    <ul className={`m-0 text-size-${fontSizeContent}`}>
                      {rightColMandatory.map((doc, index) => (
                        <li key={`${a}-${index}`}>{doc}</li>
                      ))}
                    </ul>
                  </Col>
                </Row>
                <div
                  className={`mt-2 text-size-${fontSizeContentTitle} fw-bold`}
                >
                  Opsional
                </div>
                <Row>
                  <Col md={6}>
                    <ul className={`m-0 text-size-${fontSizeContent}`}>
                      {leftColOptional.map((doc, index) => (
                        <li key={`${a}-${index}`}>{doc}</li>
                      ))}
                    </ul>
                  </Col>
                  <Col md={6}>
                    <ul className={`m-0 text-size-${fontSizeContent}`}>
                      {rightColOptional.map((doc, index) => (
                        <li key={`${a}-${index}`}>{doc}</li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </Tab.Content>
            </Tab>
          );
        })}
      </Tabs>
    </React.Fragment>
  );
}

export default RequiredDocuments;
